<template>
  <div
    data-testid="not-found-page"
    class="w-full flex items-center justify-center px-4"
    :class="isLoggedIn ? 'min-h-[60vh] py-16' : 'min-h-screen bg-gray-50/50'"
  >
    <div class="max-w-lg w-full text-center">
      <div class="mb-8 flex justify-center">
        <div class="bg-primary5 p-8 rounded-full ring-8 ring-primary5/50">
          <v-icon :icon="mdiCompassOffOutline" size="100" class="text-primary" />
        </div>
      </div>

      <p class="text-6xl md:text-7xl font-extrabold text-primary mb-2" aria-hidden="true">404</p>
      <h1 class="text-2xl md:text-3xl font-bold text-textPrimary mb-4">Página não encontrada</h1>
      <p class="text-gray-500 text-lg mb-10 leading-relaxed">
        A página que você está tentando acessar não existe, foi movida ou o endereço está incorreto.
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <FilledButton
          text="Ir para o início"
          width="220px"
          height="48px"
          data-testid="not-found-home-button"
          @click="goHome"
        />
        <OutlineButton
          v-if="canGoBack"
          text="Voltar"
          width="220px"
          height="48px"
          data-testid="not-found-back-button"
          @click="router.back()"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { mdiCompassOffOutline } from '@mdi/js'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import PATHS from '@/router/paths'
import { isCompanyAuthenticated } from '@/utils/storage'
import isSSR from '@/_base/isSSR'

const router = useRouter()

const isLoggedIn = isCompanyAuthenticated()
// vue-router 4 grava o entry anterior em history.state.back — null em deep-link direto
const canGoBack = !isSSR && Boolean(window.history.state?.back)

const goHome = () => router.push(isLoggedIn ? PATHS.DASHBOARD : PATHS.SIGNIN)

let previousTitle = ''
onMounted(() => {
  previousTitle = document.title
  document.title = 'Página não encontrada'
})
onBeforeUnmount(() => {
  document.title = previousTitle
})
</script>
